import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Button, Menu, MenuItem, MenuTrigger, Popover } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { type AgentHelpItem, trackAgentHelpItemClicked } from '../../analytics';

import styles from './AgentHelpButton.module.css';

const DISCORD_URL = 'https://discord.gg/UYyAwRU6sn';
const SUPPORT_URL = 'https://support.launchdarkly.com';

export function AgentHelpButton({ docsPath = 'home/agentcontrol' }: { docsPath?: string }) {
  return (
    <div className={styles.container}>
      <MenuTrigger>
        <Button className={styles.trigger} variant="default">
          {msg('chrome.agentHelp.trigger')}
        </Button>
        <Popover placement="top end">
          <Menu
            className={styles.menu}
            onAction={(action) => trackAgentHelpItemClicked({ item: action as AgentHelpItem })}
          >
            <MenuItem id="discord" href={DISCORD_URL} target="_blank" rel="noopener noreferrer">
              <Icon name="group-outline" size="medium" />
              <span className={styles.label}>
                <Message id="chrome.agentHelp.discord" />
              </span>
              <Icon name="link-external" size="small" />
            </MenuItem>
            <MenuItem id="product-docs" href={getDocumentationUrl(docsPath)} target="_blank" rel="noopener noreferrer">
              <Icon name="document-question" size="medium" />
              <span className={styles.label}>
                <Message id="chrome.agentHelp.productDocs" />
              </span>
              <Icon name="link-external" size="small" />
            </MenuItem>
            <MenuItem id="contact-support" href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
              <Icon name="chat-bubble-outline" size="medium" />
              <span className={styles.label}>
                <Message id="chrome.agentHelp.contactSupport" />
              </span>
              <Icon name="link-external" size="small" />
            </MenuItem>
          </Menu>
        </Popover>
      </MenuTrigger>
    </div>
  );
}
